import { Link } from "@/i18n/routing";
import { ArrowUpRight } from "lucide-react";
import React from "react";

type Props = {
  href: string;
  children: React.ReactNode;
};

const LinkItem: React.FC<Props> = ({ href, children }) => {
  return (
    <Link
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="relative my-0 inline-block hover:underline group"
    >
      {children}
      <ArrowUpRight className="size-4 inline-flex group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
    </Link>
  );
};

export default LinkItem;
